import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Text, Button } from 'react-orange-ui';
import PropTypes from 'prop-types';

import Title from '../Title/Title';
import WordingService from '../../services/WordingService';
import { path } from '../../conf/route.conf';

class ErrorView extends Component {
  handleClick = (e) => {
    e.preventDefault();

    const {
      history, quitApp, button, resetStore,
    } = this.props;

    switch (button) {
      case WordingService.getWording('button', 'tryAgain'):
        history.push(path.LOGIN);
        resetStore();
        break;
      default:
        quitApp();
    }
  };

  render() {
    const { title, message, button } = this.props;

    return (
      <Row>
        <Col sm={9} xs={12}>
          <Title id="error-title" label={title} size={64} icon="Warning important" color="orange" />
          <br />
          <Text id="error-message">
            {message}
          </Text>
          <br />
          <Button id="button-action" onClick={this.handleClick}>
            {button}
          </Button>
        </Col>
      </Row>
    );
  }
}

ErrorView.defaultProps = {
  title: WordingService.getWording('title', 'technicalError'),
  message: WordingService.getWording('errorMessage', 'technicalError'),
  button: WordingService.getWording('button', 'end'),
};

ErrorView.propTypes = {
  /** String title of error page */
  title: PropTypes.string,
  /** String message content of error page */
  message: PropTypes.string,
  /** String for the button of the error page */
  button: PropTypes.string,
  /** Action to quit the app */
  quitApp: PropTypes.func.isRequired,
  /** Object browser history */
  history: PropTypes.shape().isRequired,
  /** Action to reset the store */
  resetStore: PropTypes.func.isRequired,
};

export default ErrorView;
